import { checkRoles } from "./checkRoles";
import { REQUEST_STATE_ID_CREATED } from "../redux/constants/requestStateConstants";

export const isKsekRole = () => checkRoles("Committee", "CommitteeAdministrator");

export const canShowDocumentDeleteAction = () =>
  checkRoles("SuperAdministrator") || isKsekRole();

export const canDeleteDocumentRow = (row) => {
  if (checkRoles("SuperAdministrator")) {
    return true;
  }
  if (isKsekRole()) {
    return row?.state?.code === REQUEST_STATE_ID_CREATED;
  }
  return false;
};
